import DataUploadController from "../../../services/classes/DataUploadController";
import {ingestionHttp} from "../../../stores/init";

export const UPLOAD_MIME_TYPES = '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
export const DataIngestionUploadController = new DataUploadController(ingestionHttp, '/gcp/upload/request/');
